module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/estimate_2-8adc1e5ea198548cd585d622147a0b7a.jpg";